/**
 * @generated SignedSource<<34e12b63084cb2a35b76675c271a8171>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NavLogoHamburger_notifications$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useNotificationsConfig_notifications">;
  readonly " $fragmentType": "NavLogoHamburger_notifications";
};
export type NavLogoHamburger_notifications$key = {
  readonly " $data"?: NavLogoHamburger_notifications$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavLogoHamburger_notifications">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NavLogoHamburger_notifications",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useNotificationsConfig_notifications"
    }
  ],
  "type": "DealerNavBarBadges",
  "abstractKey": null
};

(node as any).hash = "f44aff19cd43d5c275010edd528c837f";

export default node;
